import reducer from "./reducer";
export { default as PayrollTypesSettings } from "./components/index";
export { default as payrollTypesSettingsReducerName } from "./constants";
export default reducer;
